import Vue from 'vue'
import Router from 'vue-router'
import start from '@/components/start'
import cut from '@/components/cut'
import mapcom from '@/components/mapcom'
import detail from '@/components/detail'

Vue.use(Router)

export default new Router({
  routes: [
    {
      path: '/',
      name: 'start',
      component: start,
      meta:{
        title:'剪影·百年'
      }
    },{
      path: '/cut',
      name: 'cut',
      component: cut,
      meta:{
        title:'剪影·百年'
      }
    },{
      path: '/mapcom',
      name: 'mapcom',
      component: mapcom,
      meta:{
        title:'剪影·百年'
      }
    },{
      path: '/detail',
      name: 'detail',
      component: detail,
      meta:{
        title:'剪影·百年'
      }
    }
  ]
})



// WEBPACK FOOTER //
// ./src/router/index.js